import { Link } from 'react-router-dom';
import type { MangaItem } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

interface NewArrivalSectionProps {
  mangaList: MangaItem[];
}

export default function NewArrivalSection({ mangaList }: NewArrivalSectionProps) {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  最新上架
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最近更新的韩国漫画</p>
              </div>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
              {mangaList.map((manga) => (
                <MangaCard key={manga.slug} manga={manga} />
              ))}
            </div>
          </div>

          <div className="lg:w-72 flex-shrink-0">
            <div className="bg-background-100 rounded-lg p-5 sticky top-20">
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">阅读排行榜</h3>
              <div className="space-y-4">
                {mangaList.slice(0, 5).map((manga, index) => (
                  <Link
                    key={manga.slug}
                    to={`/manga/${manga.slug}`}
                    className="flex items-center gap-3 group cursor-pointer"
                  >
                    <span className={`text-lg font-bold w-5 text-center ${
                      index === 0 ? 'text-accent-500' :
                      index === 1 ? 'text-primary-500' :
                      index === 2 ? 'text-secondary-500' :
                      'text-foreground-400'
                    }`}>
                      {index + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {manga.title}
                      </p>
                      <p className="text-xs text-foreground-500 mt-0.5">{manga.author}</p>
                    </div>
                    <span className="text-xs text-accent-500 whitespace-nowrap">★ {manga.rating}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}